import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useContext, useEffect } from "react";
import { expertContext } from "../../../../context/expertcontext";
import Steps from "./Steps";
import { toast } from "react-hot-toast";
import { uploadUrlCrocky } from "../../../../confing/confing";
import axios from "axios";
import { downloadUrl } from "../../../../confing/confing";
const Areay = ({ info, sheetId, id, token }) => {
  const { setTab, tab, setAreaInfo, imgName, setImgName, areaInfo } =
    useContext(expertContext);
  const [type, setType] = useState(0);
  const [loading, setLoading] = useState(false);

  const nextStep = (values) => {
    if (imgName || values.areay) {
      setTab(tab + 1);
    } else {
      toast.error("لطفا کروکی را وارد کنید");
    }
  };
  const previousStep = (values) => {
    if (tab > 1) {
      setTab(tab - 1);
    }
  };

  let selectfile = async (e, setFieldValue, values) => {
    try {
      setLoading(true);
      const imageFile = e.target.files[0];
      if (imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
        let size = (imageFile.size / 1024 / 1024).toFixed(2);
        if (size <= 3) {
          let datas = new FormData();
          datas.append("file", e.target.files[0]);
          const { data: imgname } = await axios.post(
            `${uploadUrlCrocky}/${sheetId}`,
            datas
          );
          console.log(imgname);
          console.log(`${uploadUrlCrocky}/${sheetId}`);
          let token = localStorage.getItem("token");
          const { data } = await axios.get(`${uploadUrlCrocky}/${sheetId}`, {
            headers: { authorization: `Bearer ${token}` },
          });
          setImgName(data.result.name);
          setLoading(false);
        } else {
          toast.error("سایز عکس باید کمتر از 2 مگابایت باشد");
          setLoading(false);
        }
      } else {
        toast.error("فرمت عکس قابل قبول نیست");
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error("دوباره تلاش کنید");
      setLoading(false);
    }
  };
  const uploadImg = async () => {
    try {
      let token = localStorage.getItem("token");
      const { data } = await axios.get(`${uploadUrlCrocky}/${sheetId}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      setImgName(data.result.name);
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      <Formik
        initialValues={{
          areay: areaInfo.north > 0 ? true : false,
          areaInfo: areaInfo,
        }}
        validationSchema={""}
        onSubmit={(values, { resetForm }) => {
          // console.log(values);
          nextStep(values);
          if (values.areay) {
            setAreaInfo(values.areaInfo);
          } else {
            setAreaInfo({
              north:  0,
              south: 0,
              west:  0,
              east:  0,
              chamfer: "",
            });
          }
        }}
        enableReinitialize={true}
      >
        {({
          isSubmitting,
          errors,
          setFieldValue,
          handleChange,
          values,
          resetForm,
        }) => (
          <Form>
            <div className="soratkarshenasi-form">
              <div className="">
                <div className="text-end">
                  <label className="">
                    ابعاد
                    <Field className="me-3" type="checkbox" name="areay" />
                  </label>
                </div>
                <div className="row">
                  <div className="mb-3 col-4 col-sm-2">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="name"
                    >
                      {" "}
                      شمال:{" "}
                    </label>
                    <Field
                      name="areaInfo.north"
                      className="w-100 karshenasi-input px-2 "
                      type="text"
                      disabled={!values.areay}
                    />
                    <ErrorMessage
                      name="areaInfo.north"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                  <div className="mb-3 col-4 col-sm-2">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="name"
                    >
                      {" "}
                      جنوب :{" "}
                    </label>
                    <Field
                      name="areaInfo.south"
                      className="w-100 karshenasi-input px-2 "
                      type="text"
                      disabled={!values.areay}
                    />
                    <ErrorMessage
                      name="areaInfo.south"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                  <div className="mb-3 col-4 col-sm-2">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="name"
                    >
                      {" "}
                      شرق :{" "}
                    </label>
                    <Field
                      name="areaInfo.east"
                      className="w-100 karshenasi-input px-2 "
                      type="text"
                      disabled={!values.areay}
                    />
                    <ErrorMessage
                      name="areaInfo.east"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                  <div className="mb-3 col-4 col-sm-2">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="name"
                    >
                      {" "}
                      غرب :{" "}
                    </label>
                    <Field
                      name="areaInfo.west"
                      className="w-100 karshenasi-input px-2 "
                      type="text"
                      disabled={!values.areay}
                    />
                    <ErrorMessage
                      name="areaInfo.west"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                  <div className="mb-3 col-4 col-sm-2">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="name"
                    >
                      {" "}
                      پخ :{" "}
                    </label>
                    <Field
                      name="areaInfo.chamfer"
                      className="w-100 karshenasi-input px-2 "
                      type="text"
                      disabled={!values.areay}
                    />
                    <ErrorMessage
                      name="areaInfo.chamfer"
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-6 text-end">
                    <p>کروکی</p>
                    <select
                      className="karshenasi-input"
                      onChange={(e) => {
                        setType(e.target.value);
                      }}
                    >
                      <option>لطفا یک گزینه انتخاب کنید</option>
                      <option value={1}>آپلود تصویر</option>
                      <option value={2}>سامانه آنلاین رسم کروکی</option>
                    </select>
                  </div>
                  {type == 1 ? (
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <p>آپلود تصویر کروکی</p>
                        <label htmlFor="upload_file">
                          <span
                            className="btn me-3"
                            style={{
                              backgroundColor: "#6BBA81",
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            آپلود فایل
                          </span>
                        </label>
                        <input
                          type="file"
                          id="upload_file"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            selectfile(e, setFieldValue);
                          }}
                        ></input>
                        {loading && (
                          <div className="spinner-border me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </div>
                      <div
                        className="my-3"
                        style={{
                          width: "80%",
                          height: "200px",
                          border: "1px solid #fff",
                          borderRadius: "15px",
                        }}
                      >
                        {imgName && (
                          <img
                            alt=""
                            width="100%"
                            height="200px"
                            src={`${downloadUrl}${imgName}`}
                          />
                        )}
                      </div>
                    </div>
                  ) : type == 2 ? (
                    <div className="col-6">
                      <div className="d-flex align-items-center">
                        <p>رسم آنلاین کروکی</p>
                        <a
                          target="_blank"
                          href={`https://crocky.koja-najafabad.ir/playground//?id=${sheetId}`}
                        >
                          <span
                            className="btn me-3"
                            style={{
                              backgroundColor: "#6BBA81",
                              color: "#fff",
                              borderRadius: "10px",
                            }}
                          >
                            ورود به سامانه
                          </span>
                        </a>
                      </div>
                      <div
                        className="my-3"
                        style={{
                          width: "80%",
                          height: "200px",
                          border: "1px solid #fff",
                          borderRadius: "15px",
                        }}
                      >
                        {imgName ? (
                          <img
                            alt=""
                            width="100%"
                            height="200px"
                            src={`${downloadUrl}${imgName}`}
                          />
                        ) : (
                          <button
                            type="button"
                            className="btn"
                            style={{ color: "#fff" }}
                            onClick={() => {
                              uploadImg();
                            }}
                          >
                            برای بارگذاری عکس اینجا کلیک کنید
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    imgName && (
                      <div className="col-6">
                        <div className="d-flex align-items-center"></div>

                        <div
                          className="my-3"
                          style={{
                            width: "80%",
                            height: "200px",
                            border: "1px solid #fff",
                            borderRadius: "15px",
                          }}
                        >
                          <img
                            alt=""
                            width="100%"
                            height="200px"
                            src={`${downloadUrl}${imgName}`}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div>
              <Steps />
              <div className="mb-2 px-2 d-flex justify-content-between">
                <div className=" request-next-btn-box mt-2">
                  <button type="submit" className="btn request-next-btn">
                    بعدی
                  </button>
                </div>
                <div className=" request-Previous-btn-box mt-2">
                  <button
                    className="btn request-Previous-btn "
                    type="button"
                    onClick={() => {
                      previousStep();
                    }}
                  >
                    قبلی
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Areay;
